import Splide from "@splidejs/splide";
import "@splidejs/splide/css";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["wrapper", "mainCarousel"];
  static values = {
    responsive: Object,
  };
  initialize() {
    if (!this.hasWrapperTarget)
      return console.error("No carousel wrapper found");

    if (this.wrapperTarget.dataset.splide) {
      this.config = JSON.parse(this.wrapperTarget.dataset.splide);
    }

    if (!this.hasMainCarouselTarget)
      return console.error("No main carousel found");

    const hasManySlides =
      this.mainCarouselTarget.querySelectorAll(".splide__slide").length > 1;

    if (this.responsiveValue) {
      this.config = {
        ...this.config,
        breakpoints: {
          1024: {
            perPage: 3,
            autoplay: false,
            drag: false,
            interval: 30000,
          },
          768: {
            perPage: 1,
            autoplay: true,
            drag: true,
            interval: 7500,
          },
        },
      };
    }
    this.mainCarousel = new Splide(this.mainCarouselTarget, {
      type: hasManySlides ? "loop" : "fade",
      perPage: 1,
      arrows: false,
      perMove: 1,
      pagination: false,
      mediaQuery: "min",
      breakpoints: {
        768: {
          perPage: 3,
        },
      },
      ...this.config,
    });

    if (this.wrapperTarget.querySelector(".carousel-thumbs")) {
      const thumbCarouselElem =
        this.wrapperTarget.querySelector(".carousel-thumbs");
      this.thumbCarousel = new Splide(thumbCarouselElem, {
        perPage: 4,
        autoHeight: true,
        pagination: false,
        arrows: false,
        isNavigation: true,
        lazyLoad: "nearby",
        gap: 10,
      });
    }

    this.renderCarousel();
  }

  renderCarousel() {
    this.thumbCarousel && this.mainCarousel.sync(this.thumbCarousel);
    this.mainCarousel.mount();
    this.thumbCarousel && this.thumbCarousel.mount();

    this.element.classList.add("is-initialized");
  }
}
